import { GerenciadorEntradasBase, type TSimulacaoParcela } from '@/domain/simulador/gerenciador-entradas-base'
import type { TGrupoParcelas } from '@/utils/calculadora-valores-totais/processador-valores-decimal'

const LIMITE_MAXIMO_ENTRADAS = 5

export class GerenciadorEntradasSacocH extends GerenciadorEntradasBase {
  override criarProximaEntrada(entradas?: TGrupoParcelas): TSimulacaoParcela {
    if (entradas && entradas.length >= LIMITE_MAXIMO_ENTRADAS) {
      throw new Error(`LIMITE_MAXIMO_ENTRADAS`)
    }

    return super.criarProximaEntrada(entradas)
  }
}
